import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'
import References from './references'

const useStyles = makeStyles(styles)


export default function Indicator(props) {
  const classes = useStyles()
  const {indicator, withReferences} = props
  return (
    <Box className={classes.root}>
      <Box className={classes.heading}>
        <Box className={classes.code}>{indicator.code}</Box>
      </Box>
      <Box className={classes.content}>
        {indicator.description && (<Box className={classes.description}>{indicator.description}</Box>)}
        <Box className={classes.references}>
          <References references={indicator.references} withReferences={withReferences} />
        </Box>
      </Box>
    </Box>
  )
}

function styles () {
  return {
    root: {
      display: 'flex',
      marginTop: 20,
      padding: '0 28px'
    },
    heading: {
      marginRight: 15
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    },
    description: {
      marginBottom: 15
    },
    code: {
      minWidth: 80,
      textAlign: 'center',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      backgroundColor: '#40f993',
      borderRadius: 3,
      fontSize: '11pt',
      padding: '3px 16px',
      color: '#000'
    },
  }
}
